module.exports = __webpack_public_path__ + "static/13th-ab085d9799fba303ab45f295337e551f.png";